import axios from 'axios';
import moment from 'moment';

/*
Andy Bernard
Oscar Martinez
Meredith Palmer 
Kevin Malone
Stanley Hudson 
Phyllis Vance
Roy Anderson 
Jan Levinson
Kelly Kapoor
Toby Flenderson
*/
class MitPeopleService {
    constructor() {
        //, 'inprogress-offer_sent', 'inprogress-waiting_background_check', 'completed'
        this.STATES = {
            NEW:{
                val:'new',
                name:'New',
                color:'blue-grey lighten-3',
                icon:'mdi-account',
                description:'',
                actionHint:''
            },
            IN_PROGRESS_OFFER_CREATED:{
                val:'progress_offer_created',
                name:'In Progress - Offer Created',
                color:'blue-grey lighten-3',
                icon:'mdi-account',
                description:'',
                actionHint:''
            },
            IN_PROGRESS_WAITING_APPROVAL:{
                val:'progress_offer_approved',
                name:'In Progress - Offer Approval',
                color:'blue-grey lighten-3',
                icon:'mdi-account',
                description:'Waiting for the offer letter to be approved',
                actionHint:'Verify the offer letter is correct and approve for sending.'
            },
            IN_PROGRESS_WAITING_TO_SEND_OFFER:{
                val:'progress_offer_sent',
                name:'In Progress - Send Offer',
                color:'blue-grey lighten-3',
                icon:'mdi-account',
                description:'',
                actionHint:'Send the offer letter when ready.'
            },
            IN_PROGRESS_WAITING_BACKGROUND:{
                val:'progress_background_check',
                name:'In Progress - Background Check',
                color:'blue-grey lighten-3',
                icon:'mdi-account',
                description:'Waiting for the background check to be completed',
                actionHint:'If the background check is sastifactory, accept this step'
            },
            IN_PROGRESS_ADD_TO_SAP:{
                val:'progress_add_sap',
                name:'In Progress - Add to SAP',
                color:'blue-grey lighten-3',
                icon:'mdi-account',
                description:'Waiting for the background check to be completed',
                actionHint:'If the background check is sastifactory, accept this step'
            },
            COMPLETED:{
                val:'completed',
                name:'Completed',
                color:'light-green lighten-2',
                // color:'primary',
                hint:''
            },
            CLOSED:{
                val:'closed',
                name:'Closed',
                color:'primary',
                hint:''
            },
        };

        this.demoPeople = [];
        this.createDemoPeople();
    }

    getStateDict() {
        return this.STATES;
    }

    createDemoPeople(){
        this.demoPeople.push({fname:'Michael', lname:'Scott', mitId:'90000001', csailId:'mscott', supervisor:'Schrute', location: {spaceId: '', needsSetup: 'Yes', setupComments: ''}, status:'Inactive', roles:'PI'});
        this.demoPeople.push({fname:'Dwight', lname:'Schrute', mitId:'90000002', csailId:'dschrute', supervisor:'Bestly', location: {spaceId: '', needsSetup: 'No', setupComments: ''}, status:'Active', roles:'AA'});
        this.demoPeople.push({fname:'Jim', lname:'Halpert', mitId:'90000003', csailId:'jhalpert', supervisor:'Bestly', location: {spaceId: '', needsSetup: 'Yes', setupComments: 'I would like a space with a window'}, status:'Pending activation', roles:'PI'});
        this.demoPeople.push({fname:'Pam', lname:'Beesly', mitId:'90000004', csailId:'pbeesly', supervisor:'Schrute', location: {spaceId: '374', needsSetup: 'Yes', setupComments: 'requested a table by the door'}, status:'Active', roles:'Student'});
        this.demoPeople.push({fname:'Ryan', lname:'Howard', mitId:'90000005', csailId:'rhoward', supervisor:'Schrute', location: {spaceId: '', needsSetup: 'Yes', setupComments: '3d floor only'}, status:'Active'});
        this.demoPeople.push({fname:'Robert', lname:'California', mitId:'90000006', csailId:'rcalifornia', supervisor:'Bestly', location: {spaceId: '', needsSetup: 'Yes', setupComments: 'requested a window'}, status:'Active'});
        this.demoPeople.push({fname:'Angela', lname:'Martin', mitId:'90000007', csailId:'amartin', supervisor:'Schrute', location: {spaceId: '124', needsSetup: 'Yes', setupComments: ''}, status:'Active'});
        this.demoPeople.push({fname:'Michel', lname:'Scotty', mitId:'90000008', csailId:'mscotty', supervisor:'Bestly', location: {spaceId: '', needsSetup: 'Yes', setupComments: 'room with 2 doors'}, status:'Active'});
        this.demoPeople.push({fname:'Dwightr', lname:'Schte', mitId:'90000009', csailId:'dschruter', supervisor:'Schrute', location: {spaceId: '', needsSetup: 'No', setupComments: ''}, status:'Incoming'});
        this.demoPeople.push({fname:'Josh', lname:'Helper', mitId:'900000010', csailId:'jhelper', supervisor:'Bestly', location: {spaceId: '', needsSetup: 'Yes', setupComments: 'window, chair, table, screen'}, status:'Inactive'});
        this.demoPeople.push({fname:'Pamkin', lname:'Bestly', mitId:'900000011', csailId:'pbestly', supervisor:'', location: {spaceId: '574', needsSetup: 'Yes', setupComments: 'requested a new chair'}, status:'Active'});
        this.demoPeople.push({fname:'Henry', lname:'Howards', mitId:'900000012', csailId:'hhowards', supervisor:'Schrute', location: {spaceId: '', needsSetup: 'Yes', setupComments: '3d floor only'}, status:'Pending activation'});
    }

    createPersonModel(person){
        person = person || {};
        person.info = person.info || {};
        if(person.info.fname && person.info.lname){
            person.info.fullName = person.info.fname + ' ' + person.info.lname ;
        }
        person.accounts = person.accounts || {};
        person.location = person.location || {};
        person.appointment = person.appointment || {};

        return{
            info:{
                fname: person.info.fname || null,
                lname: person.info.lname || null,
                mname: person.info.mname || null,
                fullName: person.info.fullName || null
            },
            accounts:{
                mitId: person.accounts.mitId || null,
                csailId: person.accounts.csailId || null,
                email:person.accounts.email || null 
            },
            location:{
                spaceId: person.location.spaceId || null,
                needsSetup: person.location.needsSetup || null,
                setupComments: person.location.setupComments || null
            },
            appointment:{
                title: person.appointment.title || null,
                start: person.appointment.start || null,
                end: person.appointment.end || null,
                salary: person.appointment.salary || null, 
                supervisor: person.appointment.supervisor || null,
                additionalSupervisors: person.appointment.additionalSupervisors || [],
                supervisees: person.appointment.supervisees || [],
                fiscal:{
                    costObjects:[
                        {
                            id:null,
                            code:null,
                            percent:0,
                            start:null,
                            end:null
                        }
                    ]
                }
            },
            appointmentHistory: person.appointmentHistory || [],
            state: person.state || 'new' 
        };
    }

    getPeople(){
        return new Promise ((resolve, reject) => {
                return resolve(this.demoPeople);
                //return reject(error);
        });
    }

    getRoles(){
        return new Promise ((resolve, reject) => {
            const roles = {
                roles:[
                    { id: 1, name: 'PI', value: 'pi' },
                    { id: 2, name: 'AA', value: 'aa' },
                    { id: 3, name: 'Staff', value: 'staff' },
                    { id: 4, name: 'Graduate Student', value: 'grad_student' },
                    { id: 5, name: 'UROP', value: 'urop' },
                    { id: 6, name: 'TEMP', value: 'temp' },
                    { id: 7, name: 'Researcher', value: 'researcher' },
                    { id: 8, name: 'Researcher2', value: 'researcher1' },
                ]
            }
                return resolve(roles);
                //return reject(error);
        });
    }
    getStatus(){
        return new Promise ((resolve, reject) => {
            const status = {
                status:[
                    { id: 1, name: 'Active', value: 'active' },
                    { id: 2, name: 'Incoming', value: 'incoming' },
                    { id: 3, name: 'Pending activation', value: 'pending' },
                    { id: 4, name: 'Auto Expire', value: 'auto_expire' },
                    { id: 5, name: 'On leave', value: 'on_leave' },
                    { id: 6, name: 'Pending activation', value: 'pending' },
                ]
            }
                return resolve(status);
                //return reject(error);
        });
    }

}

export default new MitPeopleService();
